export const deleteSpecializationsApiUrls = {
	deleteSpecialization: 'specializations/:specializationId',
};
